<template>
  <div :class="checkWidth() + ' ' + 'container'">
    <template v-if="loading">
      <div class="container vertical-center">
        <LoadingMDL />
      </div>
    </template>
    <template>
      <PopupConver
        :cardContent="content"
        :isAddQueueShow="openModalConver"
        :nextTo="funcRoute"
        :checkWidth="CheckWidth"
      />
    </template>
  </div>
</template>

<script>
import '../../../assets/scss/_chineseStyle.scss';
import '../../../assets/scss/_chineseModalCustom.scss';
import {mapGetters} from 'vuex';
import PopupConver from '../../../components/template/Chinese1/PopupConver';
import LoadingMDL from '../../../components/loading/LoadingMDL';

export default {
  components: {PopupConver, LoadingMDL},
  name: 'LKT03',
  data() {
    return {
      code: '',
      lang: '',
      content: {},
      openModalConver: true,
      CheckWidth: window.innerWidth.toString(),
      courseSection: '',
      startTime: '',
      courseCode: '',
      loading: true,
      pageCode: 'LKT03',
      str: [],
    };
  },
  computed: {
    ...mapGetters({
      // allCourse: 'template/getTemplateContent',
      // getUserTemplate: 'template/getUserTemplate',
      // getCheckAnswerResult: 'template/getCheckAnswerResult',
      getTemplatev3: 'v3/getTemplates',
    }),
  },
  watch: {
    getTemplatev3: function (val) {
      if (!val) return;

      this.v3Data = val;

      const template = val.templates[0];

      this.content = template;
      this.navigate = template.navigate;

      if (!template.enable) {
        const pathFormat = template.navigate.close.action.split('-');
        alert('Access denied!');
        this.$router.push(`/v3/${pathFormat[0]}/${pathFormat[1]}`);
      }
      // this.$store.dispatch('v3/v3FilterParent', val.codeItem);

      this.loading = false;
    },
    // allCourse: function (val) {
    //   if (!val.enable) {
    //     alert('Access denied!');
    //     this.$router.push({name: val.navigate.close.action});
    //   } else {
    //     this.content = val;
    //     this.courseSection =
    //       this.$store.getters['necessary/getUserCourseSection'];
    //     this.$store.dispatch('template/createUserTemplateData', {
    //       code: this.courseCode,
    //       template: val._id,
    //       section: this.courseSection,
    //     });
    //   }
    // },
    // getUserTemplate: function (val) {
    //   this.condition =
    //     typeof val.data.condition.criteriaType == 'undefined' ||
    //     val.data.condition.criteriaType.length == 0
    //       ? []
    //       : [
    //           {
    //             criteria: val.data.condition.criteriaType[0].criteria._id,
    //             val: val.data.condition.criteriaType[0].val,
    //           },
    //         ];
    //   this.loading = false;
    // },
    // getCheckAnswerResult: function (val) {
    //   if (val) {
    //     // this.$router.push('/' + this.str[0] + '/' + this.str[1]);
    //   }
    // },
  },
  mounted() {
    // this.lang = this.$store.state.language.language;
    // let body = {};
    // body.code = this.courseCode;
    // body.templateCode = `LKT03-` + this.$route.params.id;
    // this.$store.dispatch('template/fetchContent', body);
    this.onLoad();
  },

  created() {},

  beforeDestroy() {},
  methods: {
    onLoad() {
      this.courseCode = this.$store.state.necessary.learningCourse;
      this.startTime = this.$helpers.getDateFormat();
      this.lang = this.$store.state.language.language;

      const contentId = `LKT03-${this.$route.params.id}`;
      this.$store.dispatch('v3/fetchTemplateByCode', contentId);
    },
    checkWidth() {
      if (this.CheckWidth > 800) {
        return 'container-chinese-card';
      } else if (this.CheckWidth <= 800) {
        return 'container-chinese-card-mobile';
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    funcRoute(tempId) {
      const path = tempId.split('-');
      // this.$store.dispatch('template/saveUserTemplateData', {
      //   code: this.courseCode,
      //   template: this.content._id,
      //   section: this.courseSection,
      //   startTime: this.startTime,
      //   endTime: this.$helpers.getDateFormat(),
      //   condition: this.condition,
      // });

      const data = [
        {
          codeItem: this.v3Data.codeItem,
          courseId: this.$store.state.necessary.learningCourse,
          template: this.v3Data.templateID,
          section: this.$store.state.v3.v3EnrollData.data.section,
          content: this.v3Data.content,
          type: this.v3Data.type,
          answering: [],
          progress: 100,
          score: 0,
          maxScore: 0,
        },
      ];
      this.$store.dispatch('v3/saveContent', data);

      const nextPath = `/v3/${path[0]}/${path[1]}`;

      this.$router.push(nextPath);
    },
  },
};
</script>
<style>
@media screen and (min-width: 300px) and (max-width: 600px) {
  .talk-bubble-gray {
    width: 100px;
    height: 150px;
    margin: 20px;
  }
  .chat-text {
    line-height: 20px;
  }
}
</style>
